import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/typeClass',
      name: 'TypeClass',
      component: () => import('../views/TypeClass.vue')
    },
    {
      path: '/video',
      name: 'Video',
      component: () => import('../views/VideoView.vue')
    }
    // {
    //   path: '/my',
    //   name: 'My',
    //   component: () => import('../views/MyView.vue')
    // },
    // {
    //   path: '/invite',
    //   name: 'Invite',
    //   component: () => import('../views/InviteView.vue')
    // },
    // {
    //   path: '/deposit',
    //   name: 'Deposit',
    //   component: () => import('../views/DepositView.vue')
    // },
    // {
    //   path: '/rechargeAdmin',
    //   name: 'RechargeAdmin',
    //   component: () => import('../views/RechargeAdmin.vue')
    // },
    // {
    //   path: '/depositAdmin',
    //   name: 'DepositAdmin',
    //   component: () => import('../views/DepositAdmin.vue')
    // },
    // {
    //   path: '/caiwu',
    //   name: 'Caiwu',
    //   component: () => import('../views/CaiwuView.vue')
    // },
    // {
    //   path: '/msg',
    //   name: 'Msg',
    //   component: () => import('../views/MsgView.vue')
    // },
    // {
    //   path: '/bindBank',
    //   name: 'BindBank',
    //   component: () => import('../views/BindBank.vue')
    // },
    // {
    //   path: '/bindAddress',
    //   name: 'BindAddress',
    //   component: () => import('../views/BindAddress.vue')
    // },
    // {
    //   path: '/editPwd',
    //   name: 'EditPwd',
    //   component: () => import('../views/EditPwd.vue')
    // },
    // {
    //   path: '/editPwdto',
    //   name: 'EditPwdto',
    //   component: () => import('../views/EditPwdto.vue')
    // },
    // {
    //   path: '/lang',
    //   name: 'Lang',
    //   component: () => import('../views/LangView.vue')
    // },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: () => import('../views/LoginView.vue')
    // },
    // {
    //   path: '/register',
    //   name: 'Register',
    //   component: () => import('../views/RegisterView.vue')
    // },
    // {
    //   path: '/company',
    //   name: 'Company',
    //   component: () => import('../views/CompanyView.vue')
    // }
    // // {
    // //   path: '/video/:id',
    // //   name: 'video',
    // //   component: VideoView
    // // },
    // {
    //   path: '/kongbai',
    //   name: 'kongbai',
    //   component: KongBai
    // }
  ]
})

const whiteList = ['home', 'Video', 'TypeClass']
router.beforeEach((to, from, next) => {
  if (whiteList.includes(to.name)) {
    next()
  } else {
    // console.log('sdfsfsdf')

    next('/')
  }
})

export default router
